import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Dialog, DialogContent, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { BaseButton } from 'components/BaseButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AmendmentSuggestion } from 'services/imports/reviewAmendments';

const useStyles = makeStyles((theme: Theme) => createStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(0, 3, 3),
  },
}));

type AmountConfirmDialogProps = {
  amendment: AmendmentSuggestion | null;
  current: string | null;
  onConfirm: () => void;
  onCancel: () => void;
};

export const AmountConfirmDialog = ({ amendment, current, onConfirm, onCancel }: AmountConfirmDialogProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  const messageFor = (target: AmendmentSuggestion): string => {
    if (current === null) return t('imports:amendments.confirmAmountAdd', { key: target.key, suggested: target.value });
    return t('imports:amendments.confirmAmountReplace', { key: target.key, current, suggested: target.value });
  };
  const message = amendment === null ? '' : messageFor(amendment);

  return (
    <Dialog open={amendment !== null} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogContent className={classes.content}>
        <Typography variant="h6">{t('imports:amendments.confirmAmountTitle')}</Typography>
        <Typography variant="body2">{message}</Typography>
      </DialogContent>
      <div className={classes.actions}>
        <BaseButton
          text={t('common:cancel')}
          icon={faTimes}
          buttonVariant="outlined"
          buttonColor="inherit"
          textColor={theme.palette.text.primary}
          height={theme.spacing(5)}
          onClick={onCancel}
        />
        <BaseButton
          text={t('imports:amendments.confirm')}
          icon={faCheck}
          height={theme.spacing(5)}
          onClick={onConfirm}
        />
      </div>
    </Dialog>
  );
};
